module.exports = __webpack_public_path__ + "static/idf_skema-ee91284b4bd388184e2236f6306db02e.png";